import { FC, type JSX } from 'react';

interface Props {
  title?: string;
  subtitle?: string;
  paragraph?: string;
  children: JSX.Element[];
}

const CardsContainer: FC<Props> = ({
  title,
  subtitle,
  children,
  paragraph,
}) => {
  return (
    <div className="bg-greyscale-gray-lighter py-12">
      {(title || subtitle || paragraph) && (
        <div className="bg-greyscale-gray-lighter px-4">
          {title && (
            <h5
              className="text-center font-bold text-primary text-lg">
              {title}
            </h5>
          )}
          {subtitle && (
            <h1 className="font-bold text-center">
              {subtitle}
            </h1>
          )}
          {paragraph && <h6 className="text-center px-4 h-full">{paragraph}</h6>}
        </div>
      )}

      <div className="bg-greyscale-gray-lighter">
        <div className="section-container">
          <div className="flex flex-wrap max-md:flex-col items-stretch gap-8 justify-center bg-greyscale-gray-lighter mt-4">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardsContainer;
